export default class {
    /**
     * Intercept requests to remove trailing slashes, to avoid unnecessary redirects.
     *
     * @param request
     * @returns {*}
     */
    static request(request) {
        if (request.url.endsWith('/')) {
            request.url = request.url.substr(0, request.url.length - 1);
        }

        return request;
    }

    /**
     * Intercept responses to reject anything with a status code of 400 or more.
     *
     * @param response
     * @returns {Promise}
     */
    static response(response) {
        if (response.status >= 400) {
            return Promise.reject({ ...response });
        }

        return Promise.resolve(response);
    }

    /**
     * Handle axios error responses.
     */
    static error() {
        //
    }
}
